import moment from "moment-timezone";
export default (config, callback) => {
  if (!config) return;
  const keys = Object.keys(config);
  if (keys.length === 0) return;
  keys.forEach(function (key) {
    const startTime =
      moment(config[key].startTime).tz("Asia/Singapore") -
      moment().tz("Asia/Singapore");
    const endTime =
      moment(config[key].endTime).tz("Asia/Singapore") -
      moment().tz("Asia/Singapore");
    const warningTime =
      moment(config[key].startTime).tz("Asia/Singapore") -
      moment().tz("Asia/Singapore").add(config[key].warningBefore, "minutes");
    const obj = { ...config[key], name: key };
    const startTimeFormate = moment(config[key].startTime)
      .tz("Asia/Singapore")
      .format("DD MMM YYYY hh:mm a");
    const endTimeFormate = moment(config[key].endTime)
      .tz("Asia/Singapore")
      .format("DD MMM YYYY hh:mm a");
    const displayMsg = config[key].displayMsg
      .replace("#START#", startTimeFormate)
      .replace("#END#", endTimeFormate);
    if (warningTime >= 0 && config[key].showWarning) {
      setTimeout(() => {
        callback(key, {
          ...obj,
          displayMsg,
          warning: true,
          downtimeStarted: true,
        });
      }, warningTime);
    }
    if (startTime >= 0) {
      setTimeout(() => {
        callback(key, {
          ...obj,
          displayMsg,
          warning: false,
          downtimeStarted: true,
        });
      }, startTime);
    }
    if (endTime >= 0) {
      setTimeout(() => {
        callback(key, {
          ...obj,
          displayMsg,
          warning: false,
          downtimeStarted: false,
        });
      }, endTime);
    }
    if (startTime <= 0 && endTime >= 0) {
      callback(key, {
        ...obj,
        displayMsg,
        warning: false,
        downtimeStarted: true,
      });
    }
    if (startTime >= 0 && warningTime <= 0 && config[key].showWarning) {
      callback(key, {
        ...obj,
        displayMsg,
        warning: true,
        downtimeStarted: true,
      });
    }
  });
};
